import {createTheme} from "@mui/material/styles";

const coldEmailerTheme = createTheme({
	cssVariables: {
		colorSchemeSelector: 'data-toolpad-color-scheme',
	},
	colorSchemes: {light: true, dark: true},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 600,
			lg: 1200,
			xl: 1536,
		},
	},
	palette: {
		mode: 'light',
		background: {
			default: "#fafbfb"
		}
	}
});

export default coldEmailerTheme;
